module.exports = __webpack_public_path__ + "eacd624bc3d320e767d216ea8b4d0a6f.pdf";